import { useTranslation } from 'react-i18next';

import { useAuth } from '@/contexts/AuthContext';
import { CSVType } from '@/services/CSVService';

interface FieldInfo {
  name: string;
  required: boolean;
  type: string;
  description: string;
  example: string;
}

export function useCsvFields(csvType: CSVType) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.ProductsManager',
  });

  const { user } = useAuth();

  const arezzoFields: FieldInfo[] = [
    {
      name: 'Referência',
      required: true,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.referencia.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.referencia.example',
      ),
    },
    {
      name: 'Grupo',
      required: true,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.grupo.description',
      ),
      example: t('templateFieldsModal.fields.arezzoProducts.grupo.example'),
    },
    {
      name: 'Descrição da Sub-categoria',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoSubcategoria.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoSubcategoria.example',
      ),
    },
    {
      name: 'Descrição do Lançamento',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoLancamento.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoLancamento.example',
      ),
    },
    {
      name: 'Descrição do Tema',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoTema.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoTema.example',
      ),
    },
    {
      name: 'Descrição do Material',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoMaterial.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoMaterial.example',
      ),
    },
    {
      name: 'Descrição da Cor',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoCor.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoCor.example',
      ),
    },
    {
      name: 'Ocasião de Uso',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.ocasiaoUso.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.ocasiaoUso.example',
      ),
    },
    {
      name: 'Descrição da Categoria',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoCategoria.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.descricaoCategoria.example',
      ),
    },
    {
      name: 'Sub-categoria + Salto',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.subcategoriaSalto.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.subcategoriaSalto.example',
      ),
    },
    {
      name: 'Estilo de Produto',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.estiloProduto.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.estiloProduto.example',
      ),
    },
    {
      name: 'Mood',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.mood.description',
      ),
      example: t('templateFieldsModal.fields.arezzoProducts.mood.example'),
    },
    {
      name: 'Macrotendência',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.macrotendencia.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.macrotendencia.example',
      ),
    },
    {
      name: 'Estilo de Salto',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.estiloSalto.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.estiloSalto.example',
      ),
    },
    {
      name: 'Cabedal',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.cabedal.description',
      ),
      example: t('templateFieldsModal.fields.arezzoProducts.cabedal.example'),
    },
    {
      name: 'Tipo de Solado',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.tipoSolado.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.tipoSolado.example',
      ),
    },
    {
      name: 'Caracteristica',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.caracteristica.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.caracteristica.example',
      ),
    },
    {
      name: 'Forração do Salto',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.forracaoSalto.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.forracaoSalto.example',
      ),
    },
    {
      name: 'Fechamento',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.fechamento.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.fechamento.example',
      ),
    },
    {
      name: 'Traseiro',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.traseiro.description',
      ),
      example: t('templateFieldsModal.fields.arezzoProducts.traseiro.example'),
    },
    {
      name: 'Nível de Estilo',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.nivelEstilo.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.nivelEstilo.example',
      ),
    },
    {
      name: 'Tipo de Bico',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.tipoBico.description',
      ),
      example: t('templateFieldsModal.fields.arezzoProducts.tipoBico.example'),
    },
    {
      name: 'Grupo Cor',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.grupoCor.description',
      ),
      example: t('templateFieldsModal.fields.arezzoProducts.grupoCor.example'),
    },
    {
      name: 'Grupo Material',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.grupoMaterial.description',
      ),
      example: t(
        'templateFieldsModal.fields.arezzoProducts.grupoMaterial.example',
      ),
    },
    {
      name: 'Gênero',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.arezzoProducts.genero.description',
      ),
      example: t('templateFieldsModal.fields.arezzoProducts.genero.example'),
    },
  ];

  const productFields: FieldInfo[] = [
    {
      name: 'category',
      required: true,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.category.description',
      ),
      example: t('templateFieldsModal.fields.products.category.example'),
    },
    {
      name: 'category_id',
      required: true,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.category_id.description',
      ),
      example: t('templateFieldsModal.fields.products.category_id.example'),
    },
    {
      name: 'image_1',
      required: true,
      type: 'String',
      description: t('templateFieldsModal.fields.products.image_1.description'),
      example: t('templateFieldsModal.fields.products.image_1.example'),
    },
    {
      name: 'product_name',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.product_name.description',
      ),
      example: t('templateFieldsModal.fields.products.product_name.example'),
    },
    {
      name: 'product_id',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.product_id.description',
      ),
      example: t('templateFieldsModal.fields.products.product_id.example'),
    },
    {
      name: 'sku_id',
      required: false,
      type: 'String',
      description: t('templateFieldsModal.fields.products.sku_id.description'),
      example: t('templateFieldsModal.fields.products.sku_id.example'),
    },
    {
      name: 'ean',
      required: false,
      type: 'String',
      description: t('templateFieldsModal.fields.products.ean.description'),
      example: t('templateFieldsModal.fields.products.ean.example'),
    },
    {
      name: 'product_reference',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.product_reference.description',
      ),
      example: t(
        'templateFieldsModal.fields.products.product_reference.example',
      ),
    },
    {
      name: 'sku_reference',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.sku_reference.description',
      ),
      example: t('templateFieldsModal.fields.products.sku_reference.example'),
    },
  ];

  const shopTheLookFields: FieldInfo[] = [
    {
      name: 'product_ref',
      required: true,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.shopTheLook.product_ref.description',
      ),
      example: t('templateFieldsModal.fields.shopTheLook.product_ref.example'),
    },
    {
      name: 'related_ref_1',
      required: true,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.shopTheLook.related_ref_1.description',
      ),
      example: t(
        'templateFieldsModal.fields.shopTheLook.related_ref_1.example',
      ),
    },
    {
      name: 'related_ean_1',
      required: true,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.shopTheLook.related_ean_1.description',
      ),
      example: t(
        'templateFieldsModal.fields.shopTheLook.related_ean_1.example',
      ),
    },
    {
      name: 'product_id',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.product_id.description',
      ),
      example: t('templateFieldsModal.fields.products.product_id.example'),
    },
    {
      name: 'sku_id',
      required: false,
      type: 'String',
      description: t('templateFieldsModal.fields.products.sku_id.description'),
      example: t('templateFieldsModal.fields.products.sku_id.example'),
    },
    {
      name: 'ean',
      required: false,
      type: 'String',
      description: t('templateFieldsModal.fields.products.ean.description'),
      example: t('templateFieldsModal.fields.products.ean.example'),
    },
    {
      name: 'product_reference',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.product_reference.description',
      ),
      example: t(
        'templateFieldsModal.fields.products.product_reference.example',
      ),
    },
    {
      name: 'sku_reference',
      required: false,
      type: 'String',
      description: t(
        'templateFieldsModal.fields.products.sku_reference.description',
      ),
      example: t('templateFieldsModal.fields.products.sku_reference.example'),
    },
  ];

  const fields: FieldInfo[] = [];

  if (csvType === CSVType.PRODUCT) {
    if (user?.customer.group === 'AREZZO') {
      fields.push(...arezzoFields);
    } else {
      fields.push(...productFields);
    }
  }

  if (csvType === CSVType.SHOP_THE_LOOK) {
    fields.push(...shopTheLookFields);
  }

  return { fields };
}
